module.exports = __webpack_public_path__ + "media/images/invitation-icon-ef37bf3b79aaba4ca2bb1a16727124bf.png";